import { hentAdresse } from "../../../../../api/adressevaelger";
import { get } from "../../../../../api/util";
import { AdresseDTO } from "../../../../../interfaces/adresse";
import { CvrOpslagDto } from "../../../../../interfaces/firma";
import { adressevaelgerToAdresseDTO } from "../../../../../util/adresse";
import { dateToyyyyMMdd } from "../../../../../util/date";
import {
  OpretFirmaDTO,
  OpretFirmaStep1Formik,
  OpretFirmaStep2Formik,
} from "../../opretFirmaInterface";

export const getOpretDKFirmaDTO = async ({
  step1,
  step2,
}: {
  step1: OpretFirmaStep1Formik;
  step2: OpretFirmaStep2Formik;
}): Promise<OpretFirmaDTO> => {
  const {
    advokatVirksomhed,
    inCVR,
    land,
    produktionsenhed,
    adresseDar,
    periodeFraDato,
    virksomhedsform,
    navn,
    andenAdresse,
  } = step1;
  const {
    ean,
    email,
    emailFaktura,
    fakturaAfsend,
    phone,
    website,
    selskabstype,
  } = step2;
  const cvrOpslag =
    produktionsenhed && (land === "DK" || land === "GL")
      ? await get<CvrOpslagDto>({
          query: `grunddata/cvr?cvrNr=${produktionsenhed.cvrnummer}&pNr=${produktionsenhed.pnummer}`,
        })
      : undefined;
  let beliggenhedsadresse: AdresseDTO | undefined =
    cvrOpslag?.beliggenhedsadresse;

  if (!beliggenhedsadresse) {
    if (land === "DK") {
      const darAdresse = produktionsenhed?.adresseid
        ? await hentAdresse(produktionsenhed?.adresseid)
        : adresseDar?.darAdresseId
          ? await hentAdresse(adresseDar.darAdresseId)
          : null;
      const adresseById = darAdresse
        ? adressevaelgerToAdresseDTO(darAdresse)
        : null;

      beliggenhedsadresse = adresseById
        ? adresseById
        : inCVR === "no" && adresseDar
          ? adresseDar
          : undefined;
    } else {
      //Grønland, anden adresse
      beliggenhedsadresse = { ...andenAdresse, landekode: land };
    }
  }

  let kommuneNr = cvrOpslag?.kommuneNr ?? null;
  let retskredsNr = land === "GL" ? 99 : (cvrOpslag?.retskredsNr ?? null);
  if (!kommuneNr && !retskredsNr && adresseDar && land === "DK") {
    const dagiData = await get<{
      kommuneNr: number;
      retskredsKode: string;
      retskredsNr: number;
    }>({
      query: `grunddata/admin?darId=${adresseDar.darAdresseId}`,
    });
    kommuneNr = dagiData.kommuneNr;
    retskredsNr = dagiData.retskredsNr;
  }

  const general = {
    advokatVirksomhed,
    beliggenhedsadresse: beliggenhedsadresse!,
    ean,
    email,
    bemaerkninger: null,
    kredsNr: land === "GL" ? 1 : null,
    webAdresse: website,
    tlf: phone,
    navn2: null,
    navn3: null,
    kommuneNr,
    regionNr: null,
    retskredsNr,
    periodeFraDato: periodeFraDato ? dateToyyyyMMdd(periodeFraDato) : null,
    fakturaAfsend: fakturaAfsend ?? null,
    fakturaEmail: emailFaktura,
    virksomhedsform: cvrOpslag?.virksomhedsform
      ? cvrOpslag?.virksomhedsform
      : (virksomhedsform ?? null),
  };

  return inCVR !== "no"
    ? {
        ...general,
        cvrNr: produktionsenhed?.cvrnummer ?? null,
        pnr: produktionsenhed?.pnummer ?? null,
        navn1: produktionsenhed?.navn ?? null,
        selskabstype: null,
      }
    : {
        ...general,
        cvrNr: null,
        navn1: navn,
        selskabstype: selskabstype ? parseInt(selskabstype) : null,
        pnr: null,
      };
};
